import React from 'react';
import PropTypes from 'prop-types';
import style from '../Debug.module.scss';

const BlackoutPanel = (props = {}) => {
  const { handleSetBlackoutFetchInterval, blackoutFetchDuration } = props;

  return (
    <div className={style.panel}>
      <div className={style.header}>Blackout</div>
      <div className={style.body}>
        <div className={style.formLabel}>Blackout Fetch Duration (milliseconds)</div>
        <div>
          <input
            type="text"
            value={blackoutFetchDuration || ''}
            onChange={handleSetBlackoutFetchInterval}
          />
        </div>
      </div>
    </div>
  );
};

BlackoutPanel.propTypes = {
  blackoutFetchDuration: PropTypes.number,
  handleSetBlackoutFetchInterval: PropTypes.func.isRequired,
};

export default BlackoutPanel;
